import {Component} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {WmNotificationService} from '@webmate-web-core/shared/components/notification/wm-notification.service';


@Component({
    selector: 'wm-signup',
    styleUrls: ['./signup.component.less'],
    templateUrl: './signup.component.html'
})
export class SignupComponent {

    form: UntypedFormGroup;

    defaultErrorMsg = "There was an error during sign-up. Please contact our support team at <a href=\"mailto:support@testfabrik.com\" target=\"_blank\">support@testfabrik.com</a> or at <a href=\"https://support.testfabrik.com\" target=\"_blank\">support.testfabrik.com</a>";

    signUpBusy: boolean = false;
    signupFailure?: string = undefined;

    constructor(private OAuth2AuthService: AuthService, private route: ActivatedRoute, private router: Router, private notificationService: WmNotificationService){}

    ngOnInit() {
        this.form = new UntypedFormGroup({
            username: new UntypedFormControl('', Validators.required),
            email: new UntypedFormControl('', [Validators.required, Validators.email]),
            organization: new UntypedFormControl(''),
            privacypolicy: new UntypedFormControl(false, Validators.requiredTrue)
        })
    }

    submitSignup() {
        this.signUpBusy = true;
        this.form.disable();
        this.OAuth2AuthService.registerCustomer(this.form.controls.email.value, this.form.controls.username.value, this.form.controls.organization.value, this.form.controls.privacypolicy.value)
            .subscribe(
            authSuccess => {
                if (authSuccess) {
                    this.form.reset();
                    //Comment this in to enable the onboarding modal
                    this.notificationService.simpleNotification("We send you a verification email. Please check your email account to complete your registration!")
                    this.signUpBusy = false;
                } else {
                    // TODO check and display potential error cases
                    this.form.enable();
                    this.signUpBusy = false;
                    this.signupFailure = this.defaultErrorMsg;
                }
            }, error => {
                this.form.enable();
                this.signUpBusy = false;
                this.signupFailure = error?.error?.split(': ')[1];
                if (!this.signupFailure) {
                    this.signupFailure = this.defaultErrorMsg;
                }
            });
    }
}
